export default "__VITE_ASSET__47f8c23b__"